import React from 'react';
import { text } from '../../data';
import Loader from '../../../components/bearing-search/components/Loader';

interface SealModalProps {
    partNumber: string;
    onClose: () => void;
}

const SealModal: React.FC<SealModalProps> = ({
     partNumber,
     onClose,
 }) => {
    return (
        <div
            className={partNumber.trim() !== "" ? 'c-search-modal show' : 'c-search-modal'}
            data-id={partNumber.trim()}
            role="dialog"
            aria-modal="true"
            aria-hidden={partNumber === "" ? 'true' : 'false'}>
            <div className="c-search-modal__backdrop" onClick={onClose}></div>
            {partNumber.trim() === "true" && <Loader />}
            {partNumber.trim() !== "true" && partNumber.trim() !== "" && (
                <div className="c-search-modal__content c-search-modal__content--seal-modal">
                    <div className="c-part-search c-part-search--seal-modal">
                        No Seal found with Part Number { partNumber.trim() }. <br/>
                        <a href="https://www.timken.com/resources/national-industrial-seals-catalog/" target="_blank">Click here</a> to view Timken Seals Catalog.
                    </div>
                    <button className="c-search-modal__close" type="button" onClick={onClose}>
                        <span className="sr-only">{text.close}</span>
                        <div className="icon-close" aria-hidden="true"></div>
                    </button>
                </div>
            )}
        </div>
    );
};

export default SealModal;
